// @ts-nocheck
import { getTrackingInfo } from "@store/Framework/Services/Pages/OrderDetails/TrackingInfoService";
import { TrackingInfoModel } from "@store/Framework/Types/TrackingInfoModel";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type GetTrackingInfoParameter = {
    erpOrderNumber: string;
};

type HandlerType = ApiHandler<GetTrackingInfoParameter, TrackingInfoModel>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getTrackingInfo(props.parameter.erpOrderNumber);
};

export const DispatchCompleteGetMemberInfo: HandlerType = props => {
    const { dispatch, apiResult } = props;
    dispatch({
        type: "Store/Pages/OrderDetails/GetTrackingInfo",
        trackingInfo: apiResult,
    });
};

export const chain = [RequestDataFromApi, DispatchCompleteGetMemberInfo];

const getDeliveryInfo = createHandlerChainRunner(chain, "GetDeliveryInfo");
export default getDeliveryInfo;
